import Cookies from 'js-cookie';

const CONSENT_COOKIE = 'COOKIE_CONSENT';
const CONSENT_ACCEPT_LIFETIME = 365;
const CONSENT_REJECT_LIFETIME = 365;
const GA_COOKIE_NAMES = ['__utma', '__utmb', '__utmc', '__utmz', '_ga', '_gat', '_gid', '__unam', 'NID'];
const ALL_COOKIES = {
    version: 3,
    google: {
        analytics: true,
        adwords: true,
        maps: true,
        social: true,
        login: true
    },
    facebook: {
        social: true,
        login: true,
        analytics: true
    },
    criteo: {
        retargeting: true
    },
    xiti: {
        analytics: true
    },
    addthis: {
        social: true
    },
    sharethis: {
        social: true
    },
    smartfocus: {
        retargeting: true
    },
    twitter: {
        social: true
    },
    linkedin: {
        social: true
    },
    pinterest: {
        social: true
    },
    stumbleupon: {
        social: true
    },
    whatsapp: {
        social: true
    },
    others: true
};
const DIV_IDS = ['cookie-banner', 'cookie-inform-and-ask'];
const TEMPLATE = `<div id="cookie-banner" class="cookie-banner">
  <div class="cookie-banner-text">
    <div>
      Sur le site __BUSINESS_NAME__ nous utilisons des cookies pour garantir la meilleure navigation possible, afficher des offres et services adaptés 
      à vos préférences, proposer des fonctions de partage vers les réseaux sociaux et analyser le trafic du site pour améliorer votre 
      expérience sur le site. En poursuivant la navigation sur le site, vous acceptez l’utilisation des cookies. Pour plus d’informations et 
      pour paramétrer les cookies, <a href="javascript:" id="cookie-more-button" name="cookie-more">cliquez ici</a>.
    </div>
  </div>
  <div class="cookie-banner-button">
    <div>
      <button id="cookie-accept-button" name="cookie-accept">OK, j'ai compris</button>  
    </div>
  </div>
</div>
<div id="cookie-inform-and-ask" class="cookie-inform-and-ask">
  <div class="cookie-dialog">
    <div class="cookie-dialog-title">
      Gestion des cookies
    </div>
    <div class="cookie-dialog-heading">
      __BUSINESS_NAME__ utilise les cookies afin de vous proposer un service web amélioré et personnalisé. Vous pouvez décider d’accepter 
      ou non nos cookies.
    </div>
    <div class="cookie-dialog-section">
      <div class="cookie-dialog-section-title">
        Cookies de service et de personnalisation
      </div>
      <div class="cookie-dialog-section-action">
        <div class="cookie-dialog-onoffswitch">
          <input type="checkbox" class="cookie-dialog-onoffswitch-checkbox" id="switch_section_1" checked
                 value="google.analytics,google.maps,facebook.analytics,xiti.analytics">
          <label class="cookie-dialog-onoffswitch-label" for="switch_section_1">
            <span class="cookie-dialog-onoffswitch-inner"></span>
            <span class="cookie-dialog-onoffswitch-switch"></span>
          </label>
        </div>
      </div>
      <div class="cookie-dialog-section-text">
        Ces cookies permettent de vous offrir une expérience sur le site en fonction de votre navigation.
      </div>
    </div>
    <div class="cookie-dialog-section">
      <div class="cookie-dialog-section-title">
        Cookies publicitaire
      </div>
      <div class="cookie-dialog-section-action">
        <div class="cookie-dialog-onoffswitch">
          <input type="checkbox" class="cookie-dialog-onoffswitch-checkbox" id="switch_section_2" checked
                 value="google.adwords,criteo.retargeting,smartfocus.retargeting,others">
          <label class="cookie-dialog-onoffswitch-label" for="switch_section_2">
            <span class="cookie-dialog-onoffswitch-inner"></span>
            <span class="cookie-dialog-onoffswitch-switch"></span>
          </label>
        </div>
      </div>
      <div class="cookie-dialog-section-text">
        Ces cookies permettent à nos partenaires publicitaires de vous envoyer des messages ciblés et personnalisés.
      </div>
    </div>
    <div class="cookie-dialog-section">
      <div class="cookie-dialog-section-title">
        Cookies réseaux sociaux
      </div>
      <div class="cookie-dialog-section-action">
        <div class="cookie-dialog-onoffswitch">
          <input type="checkbox" class="cookie-dialog-onoffswitch-checkbox" id="switch_section_3" checked
                 value="google.login,facebook.login,google.social,facebook.social,addthis.social,sharethis.social,twitter.social,linkedin.social,pinterest.social,stumbleupon.social,whatsapp.social">
          <label class="cookie-dialog-onoffswitch-label" for="switch_section_3">
            <span class="cookie-dialog-onoffswitch-inner"></span>
            <span class="cookie-dialog-onoffswitch-switch"></span>
          </label>
        </div>
      </div>
      <div class="cookie-dialog-section-text">
        Ces cookies permettent de faciliter le partage sur les réseaux sociaux ou de vous connecter via votre compte du réseau social.
      </div>
    </div>
    <div class="cookie-dialog-footer">
      <button id="ga-confirm-button" name="ga-confirm">Valider ma sélection</button>
    </div>
  </div>
</div>
`;

class CookieConsent {
    constructor() {
        this.cookieBanner = null;
        this.cookieInformAndAsk = null;
        this.cookieMoreButton = null;
        this.gaConfirmButton = null;
        this.started = false;
        this.options = {
            ga_tracking_id: null,
        };
    }

    processCookieConsent(options) {
        const consentCookie = Cookies.getJSON(CONSENT_COOKIE) || {set: false};
        const doNotTrack = navigator.doNotTrack || navigator.msDoNotTrack;

        Object.assign(this.options, options);

        if (doNotTrack === 'yes' || doNotTrack === '1') {
            this.reject();
            return;
        }

        if (consentCookie.set === true) {
            if (consentCookie.reject === true) {
                this.reject();
                return;
            }

            if (!consentCookie.cookies.version || consentCookie.cookies.version !== ALL_COOKIES.version) {
                Cookies.remove(CONSENT_COOKIE);
            } else {
                this.startCookieConsent(consentCookie.cookies);
                return;
            }
        }

        const template = document.createElement('div');
        template.innerHTML = TEMPLATE.replace(/__BUSINESS_NAME__/g, options.business_name || 'ce site internet');
        document.getElementsByTagName('body').item(0).appendChild(template);

        this.cookieBanner = document.getElementById('cookie-banner');
        this.cookieInformAndAsk = document.getElementById('cookie-inform-and-ask');
        this.cookieMoreButton = document.getElementById('cookie-more-button');
        this.gaConfirmButton = document.getElementById('ga-confirm-button');

        this.cookieBanner.classList.add('active');
        this.cookieMoreButton.addEventListener('click', this.onMoreButtonClick.bind(this), false);
        document.addEventListener('click', this.onDocumentClick.bind(this), false);
    }

    reject() {
        this.rejectGoogleAnalytics();
        Cookies.set(CONSENT_COOKIE, {set: true, reject: true}, {expires: CONSENT_REJECT_LIFETIME});
    }

    rejectGoogleAnalytics() {
        if (this.options.ga_tracking_id) {
            Cookies.set(`ga-disable-${this.options.ga_tracking_id}`, true, {expires: CONSENT_REJECT_LIFETIME});
            window[`ga-disable-${this.options.ga_tracking_id}`] = true;
        }

        GA_COOKIE_NAMES.forEach(cookieName => Cookies.remove(cookieName));
    }

    onDocumentClick(event) {
        const consentCookie = Cookies.getJSON(CONSENT_COOKIE) || {set: false};

        if (consentCookie.set === true) {
            return;
        }

        let item = event.target;

        if (item.id !== 'cookie-accept-button') {
            do {
                if (DIV_IDS.reduce((found, id) => found || id === item.id, false)) {
                    return;
                }

                item = item.parentNode;
            } while (item);
        }

        event.preventDefault();
        this.accept('all');
        this.cookieBanner.className = this.cookieBanner.className.replace('active', '').trim();
        document.removeEventListener('click', this.onDocumentClick, false);
        this.cookieMoreButton.removeEventListener('click', this.onMoreButtonClick, false);
    }

    onMoreButtonClick(event) {
        event && event.preventDefault();
        this.cookieInformAndAsk.classList.add('active');
        this.cookieBanner.className = this.cookieBanner.className.replace('active', '').trim();
        this.gaConfirmButton.addEventListener('click', this.onGaConfirmButtonClick.bind(this), false);
        document.removeEventListener('click', this.onDocumentClick, false);
        this.cookieMoreButton.removeEventListener('click', this.onMoreButtonClick, false);
    }

    onGaConfirmButtonClick(event) {
        event.preventDefault();
        const cookies = this.getSelection();
        Cookies.set(CONSENT_COOKIE, {set: true, reject: false, cookies: cookies}, {expires: CONSENT_ACCEPT_LIFETIME});
        this.startCookieConsent();
        this.cookieInformAndAsk.className = this.cookieInformAndAsk.className.replace('active', '').trim();
        this.gaConfirmButton.removeEventListener('click', this.onGaConfirmButtonClick, false);
    }

    getSelection() {
        let cookies = {
            version: ALL_COOKIES.version,
        };
        const checkboxes = document.getElementsByClassName('cookie-dialog-onoffswitch-checkbox');

        Array.from(checkboxes).forEach(el => el.value.split(',').forEach(token => {
            let node = cookies, i = 0;
            const items = token.split('.');
            for (; i < items.length - 1; ++i) {
                node = node[items[i]] = node[items[i]] || {}
            }
            node[items[i]] = !!el.checked;
        }));

        return cookies;
    }

    reset() {
        Cookies.remove(CONSENT_COOKIE);
        this.started = false;
    }

    accept(cookies) {
        if (cookies === 'all') {
            cookies = ALL_COOKIES;
        }

        Cookies.set(CONSENT_COOKIE, {set: true, reject: false, cookies: cookies}, {expires: CONSENT_ACCEPT_LIFETIME});
        this.startCookieConsent();
    }

    startCookieConsent() {
        if (this.started) {
            return;
        }

        this.started = true;

        const consentCookie = Cookies.getJSON(CONSENT_COOKIE) || {set: false};

        if (consentCookie.set && !consentCookie.reject) {
            this.listeners = this.listeners || window.startCookieConsent || [];
            this.listeners.forEach(cb => cb(consentCookie.cookies));
        }

        if (!window.startCookieConsent || typeof window.startCookieConsent.forEach === 'function') {
            this.listeners = this.listeners || window.startCookieConsent || [];
            window.startCookieConsent = {
                push: cb => this.listeners.push(cb) && cb(consentCookie.cookies)
            };
        }
    }

    edit() {
        this.reset();
        this.processCookieConsent(this.options);
        this.onMoreButtonClick();
    }
}

let cookieConsent = new CookieConsent();

window.askCookie = () => cookieConsent.edit();

export default cookieConsent;



// WEBPACK FOOTER //
// ./resources/assets/js/cookie.js